import { Badge, IconButton, Image, Tooltip } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const CloseButton = styled(IconButton)`
  position: absolute;
  right: -8px;
  top: -8px;
  z-index: 20;
`;

const EGiftCardInternationalTooltipWrapper = styled.div`
  bottom: 0;
  position: absolute;
  right: 0;
`;

const InfoWrapper = styled.div`
  flex: 1;
  padding: 0 8px;
  position: relative;
`;

const ListContainer = styled.div`
  .product-see-more-container,
  .product-see-more-container.show-more {
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    margin-bottom: 16px;
    margin-top: 16px;
    overflow: inherit;
  }
`;

const ListContainerLoading = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  height: 100px;
  margin-bottom: 16px;
  margin-top: 16px;
  overflow: inherit;
`;

const Name = styled.div`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: var(--color-fg-default);
  display: -webkit-box;
  font-size: 12px;
  line-height: 18px;
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 100px);
`;

const Price = styled.div`
  color: var(--color-fg-default);
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  margin-top: 4px;
`;

const ProductInfoImage = styled.div`
  align-items: center;
  background: var(--color-bg-default);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-sm);
  display: flex;
  height: 32px;
  justify-content: center;
  max-width: 60px;
  padding: 6px;
  position: absolute;
  right: 0;
  top: 0;
  width: fit-content;

  img {
    height: 100%;
    object-fit: contain;
    width: 100%;
  }
`;

const ProductStockInfo = styled.div`
  position: absolute;
  right: 12px;
  top: 12px;
  width: fit-content;
  z-index: 10;

  ${Tooltip.S?.TooltipContent} {
    width: 304px;
  }
`;

const ProductStockInfoOverlay = styled.div`
  background-color: rgba(255, 255, 255, 0.6);
  inset: 0;
  position: absolute;
`;

const ProductStockWrapper = styled.div`
  position: absolute;
  right: 24px;
  top: 8px;

  ${Badge.S.BadgeWrapper} {
    border-color: var(--color-warning-default);
    color: var(--color-fg-strongest);
    font-weight: 600;
  }
`;

const ProductVerticalList = styled.div`
  .button-wrapper {
    align-items: center;
    display: flex;
    justify-content: center;

    button {
      text-transform: uppercase;
    }
  }
`;

const VerticalListItem = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  height: auto;
  padding: 8px;
  position: relative;
  transition: all 0.3s ease-in-out;
  width: 100%;

  ${({ isAllSkuAvailable }) =>
    !isAllSkuAvailable &&
    css`
      cursor: not-allowed;
    `}

  &:hover {
    border: 1px solid var(--color-accent-secondary-weaker);
    box-shadow: var(--shadow-s);
  }

  ${Image.S.Image} {
    border-radius: var(--size-border-radius-md);
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      border: 1px solid var(--color-border-default);
    `}
`;

export {
  CloseButton,
  EGiftCardInternationalTooltipWrapper,
  InfoWrapper,
  ListContainer,
  ListContainerLoading,
  Name,
  Price,
  ProductInfoImage,
  ProductStockInfo,
  ProductStockInfoOverlay,
  ProductStockWrapper,
  ProductVerticalList,
  VerticalListItem
};
